import { MelioLogo } from '@/components/ds';
import { useGo } from '@/lib/useGo';

export function Footer() {
  const go = useGo();
  const cols: [string, string[]][] = [
    ['Product', ['Overview', 'Pricing', 'Status', 'Changelog']],
    ['Developers', ['API reference', 'Quickstart', 'SDKs', 'AI & agents']],
    ['Resources', ['Guides', 'Webhooks', 'Support', 'Compliance']],
  ];
  return (
    <footer style={{ borderTop: '1px solid var(--border-static)', background: '#fff', marginTop: 24 }}>
      <div style={{ padding: '44px 28px 36px', display: 'grid', gridTemplateColumns: '1.4fr repeat(3, 1fr)', gap: 32 }}>
        <div>
          <MelioLogo height={22} />
          <p style={{ fontSize: 13, lineHeight: '20px', color: 'var(--text-secondary)', margin: '14px 0 0', maxWidth: 240 }}>
            Payments for small businesses. Pay any business by ACH or check, over one API.
          </p>
        </div>
        {cols.map(([h, items]) => (
          <div key={h}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12 }}>{h}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
              {items.map((it) => (
                <a
                  key={it}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (it === 'API reference') window.location.assign('/docs');
                    if (it === 'AI & agents') go('/agents');
                  }}
                  style={{ fontSize: 13, color: 'var(--text-secondary)', textDecoration: 'none' }}
                >
                  {it}
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div style={{ borderTop: '1px solid var(--border-static)' }}>
        <div
          style={{ padding: '18px 28px', display: 'flex', alignItems: 'center', gap: 12, fontSize: 12.5, color: 'var(--text-secondary)' }}
        >
          <span>© 2026 Melio Payments Inc.</span>
          <span style={{ flex: 1 }} />
          <span>Terms</span>
          <span>Privacy</span>
          <span>Security</span>
        </div>
      </div>
    </footer>
  );
}
